import { useLanguage } from 'context/language.context';
import { cn } from 'lib/utils';
import { FC, HTMLAttributes, useEffect, useRef, useState } from 'react';

interface TypeWriterProps {
  text: string;
  className?: HTMLAttributes<HTMLDivElement>['className'];
}

export const TypeWriter: FC<TypeWriterProps> = ({ text, className }) => {
  const { direction } = useLanguage();
  const [typedText, setTypedText] = useState<string>('');
  const [height, setHeight] = useState<number>(0);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setTypedText('');

    setTimeout(() => {
      let counter = 0;
      const interval = setInterval(() => {
        setTypedText(text.slice(0, counter + 1));
        counter++;
        if (counter === text.length) {
          clearInterval(interval);
        }
      }, 50);
    }, 500);
  }, []);

  useEffect(() => setTypedText(text), [direction, text]);

  useEffect(() => {
    const renderedText = ref.current;
    if (!renderedText) return;

    const resizeObserver = new ResizeObserver(() => {
      setHeight(renderedText.offsetHeight);
    });

    resizeObserver.observe(renderedText);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <>
      <div
        className={cn(
          `after:absolute after:w-1.5 after:mx-1.5 after:h-[20px] after:bg-primary-white-1 after:animate-caret`,
          className,
        )}
        style={{
          minHeight: `${height}px`,
        }}
      >
        {typedText}
      </div>
      <div ref={ref} className="absolute z-[-1] h-fit opacity-0">
        {text}
      </div>
    </>
  );
};
